import {Component, OnInit, OnDestroy, AfterViewChecked, HostListener, Renderer2, AfterViewInit} from '@angular/core';
import {Router, ActivationStart} from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { IntervalObservable } from 'rxjs/observable/IntervalObservable'
import * as moment from 'moment';
import * as numeral from 'numeral/numeral';
import 'numeral/locales';
import 'rxjs/add/operator/takeWhile';
import { LoginService } from 'app/services/login.service';


import { CommonDataService } from 'app/services/common-data.service';
import {MainHelper} from "../../shared/models/main-helper";
import {CommonService} from "../../services/common.service";
// require('../../../../node_modules/numeral/locales/lnumeral/locales/lt');
// require('numeral/locales/pl');


@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit, OnDestroy, AfterViewChecked, AfterViewInit {
    constructor(private readonly loginService: LoginService,
                public readonly commonData: CommonDataService,
                private readonly translateService: TranslateService,
                private readonly commonService: CommonService,
                private readonly router: Router,
                public renderer: Renderer2) {
        this.focusIdx = 0;
        this.buttonsActive = [];
        this.helper = new MainHelper();

    }

    private destroyed: boolean;

    private siteAddress: string;

    public focusIdx: number;

    public buttonsActive: boolean [];

    public firstActive: boolean;

    public helper: MainHelper;

    async ngOnInit(): Promise<void> {
        this.translateService.setDefaultLang('en');

        let localeConfigured = false;
        this.router.events.takeWhile(() => !this.destroyed && !localeConfigured).subscribe(e => {
            if (!(e instanceof ActivationStart))
                return;

            let event = e as ActivationStart;
            const locale = event.snapshot.queryParams['culture'] || this.commonData.language || this.translateService.getBrowserLang() || 'en';
            this.translateService.use(locale);
            sessionStorage.setItem('userLocale', locale);
            // let lt = require('../../../../node_modules/numeral/locales/lt')
                // pl = require('numeral/locales/pl');
            moment.locale(locale);
            let getNumeralLocale = () => {
                switch (locale){
                    case 'uk': return 'uk-ua'
                    case 'lt': return 'en'
                    default: return locale
                }
            }

            numeral.locale(getNumeralLocale());
            localeConfigured = true;
        });

        new IntervalObservable(1000).takeWhile(() => !this.destroyed)
            .subscribe(() => $('.tooltip.show').filter((i: number, t: HTMLElement) => $(`[data-toggle=tooltip][aria-describedby="${t.id}"]`).length === 0).remove());

        this.loginService.getSiteAddress().subscribe(data => {
                if (!data || !data.success) {
                    this.commonData.showLoadingImg = false;
                    this.commonData.showErrors(['Reload page Please'])
                }
                // this.commonData.showLoadingImg = false;
                this.siteAddress = data.siteAddress;
            },
            e => {
                this.commonData.showErrors([e.message || e]);

                this.commonData.showLoadingImg = false;
            });

        /*let prop = await this.commonService.getSettings(['GoogleAnalyticsID']).toPromise();

        console.log(prop);

        if (prop && prop.success && prop.settings.length){
            let GAID = prop.settings.filter(item => item.name === 'GoogleAnalyticsID');
            GAID && GAID.length && (<any>window).ga('create', GAID[0].value, 'auto');
            this.router.events.subscribe(event => {
                if (event instanceof NavigationEnd) {
                    (<any>window).ga('set', 'page', event.urlAfterRedirects);
                    (<any>window).ga('send', 'pageview');
                }
            });
        }*/
    }

    ngAfterViewInit(): void{
        //var isFirefox = typeof InstallTrigger !== 'undefined';
        //var isSafari = /constructor/i.test(window.HTMLElement) || (function (p) { return p.toString() === "[object SafariRemoteNotification]"; })(!window['safari'] || (typeof safari !== 'undefined' && safari.pushNotification));

        /*console.log(navigator.userAgent, 'navigator.userAgent')

        if (navigator.userAgent.toLowerCase().indexOf('firefox') > -1){
            $('body').addClass('firefox')
        } else if (navigator.userAgent.toLowerCase().indexOf('maxthon') > -1){
            $('body').addClass('maxthon')
        }*/

        // Get the user-agent string
        let userAgentString =
            navigator.userAgent;

        // Detect Chrome
        let chromeAgent =
            userAgentString.indexOf("Chrome") > -1;

        // Detect Internet Explorer
        // let IExplorerAgent =
        //     userAgentString.indexOf("MSIE") > -1 ||
        //     userAgentString.indexOf("rv:") > -1;

        // Detect Firefox
        // let firefoxAgent =
        //     userAgentString.indexOf("Firefox") > -1;

        // Detect Safari
        let safariAgent =
            userAgentString.indexOf("Safari") > -1;

        // Discard Safari since it also matches Chrome
        if ((chromeAgent) && (safariAgent))
            safariAgent = false;

        // Detect Opera
        // let operaAgent =
        //     userAgentString.indexOf("OP") > -1;

        // Discard Chrome since it also matches Opera
        // if ((chromeAgent) && (operaAgent))
        //     chromeAgent = false;

        // Detect Safari
        let maxthonAgent =
            userAgentString.indexOf("Maxthon") > -1;

        if (safariAgent || maxthonAgent){
            $('body').addClass('safari')
        }

        if (maxthonAgent){
            $('body').addClass('maxthone')
        }

    }

    ngOnDestroy(): void {
        this.destroyed = true;
    }

    ngAfterViewChecked(): void {
        if (this.commonData.popupActive && this.firstActive)
            return;
        else if (!this.commonData.popupActive && this.firstActive)
            setTimeout(() => {
                this.firstActive = false;
            },1);


        if (this.commonData.popupActive && !this.firstActive) {
            setTimeout(() => {
                this.firstActive = true;

                if (this.commonData.dialogType !== 'Question') this.buttonsActive[0] = true;
                if (this.commonData.dialogType === 'Question' && this.commonData.dialogOnYes) this.buttonsActive[1] = true;
                if (this.commonData.dialogType === 'Question' && this.commonData.dialogOnNo) this.buttonsActive[2] = true;
                if (this.commonData.dialogType === 'Question' && this.commonData.dialogOnCancel) this.buttonsActive[3] = true;

                this.buttonsActive.forEach((item, i) => {
                    if (item) this.focusIdx = i;
                });
            },1)

        }
    }

    @HostListener('window:mousemove', ['$event']) onMouseMove(e: MouseEvent){
        // console.log('window:mousemove')
        this.commonService.setMouseMove(e);
    }

    @HostListener('document:pointermove', ['$event']) onPointerMove(event: PointerEvent){
        // console.log(event, event.pointerId, 'onPointerMove')
        this.commonService.setPointerMove(event);
    }

    @HostListener('window:message', ['$event']) onMessage(e: MessageEvent) {
        if (e.origin === 'http://' + this.siteAddress || e.origin === 'https://' + this.siteAddress ) {
            if (e.data === 'close'){
                setTimeout(() => this.logoOut(), 50);
            }
        }
    }

    public saveClick = (e: MouseEvent): void => {
        this.commonService.setMouseDown(e);
    }

    public handleKeyEvent = (event: KeyboardEvent): void => {
        if (!this.commonData.popupActive) return;

        let focusIdx = this.focusIdx;

        if (event.keyCode === 39 && focusIdx < 3) {
            if (this.buttonsActive[focusIdx + 1]) this.focusIdx = ++focusIdx;
            else {
                while (focusIdx < 3) {
                    focusIdx++;
                    if (this.buttonsActive[focusIdx + 1]) {
                        this.focusIdx = ++focusIdx;
                        break
                    }
                }
            }
        } else if (event.keyCode === 37 && focusIdx > 0){
            if (this.buttonsActive[focusIdx - 1]) this.focusIdx = --focusIdx;
            else {
                while (focusIdx > 0) {
                    focusIdx--;
                    if (this.buttonsActive[focusIdx - 1]) {
                        this.focusIdx = --focusIdx;
                        break
                    }
                }
            }
        }
    };

    public onDialogButtonPress = (action: () => void) => {
        if (action)
            setTimeout(action, 1);
    };

    public onDialogSelect = (action: (idx: number) => void, idx: number) => {
        if (action){
            setTimeout(() => action(idx), 1);
        }

    };

    public logoOut = (): boolean => {
        this.loginService.logout().subscribe(data => {
            if (data.success)
                window.location.reload();
        }, e => this.commonData.showErrors([e.message || e]));

        return false;
    }
}



// WEBPACK FOOTER //
// ./src/app/components/app/app.component.ts